import { render, staticRenderFns } from "./SidebarTitle.vue?vue&type=template&id=278f888a&scoped=true"
import script from "./SidebarTitle.vue?vue&type=script&lang=js"
export * from "./SidebarTitle.vue?vue&type=script&lang=js"
import style0 from "./SidebarTitle.vue?vue&type=style&index=0&id=278f888a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f888a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278f888a')) {
      api.createRecord('278f888a', component.options)
    } else {
      api.reload('278f888a', component.options)
    }
    module.hot.accept("./SidebarTitle.vue?vue&type=template&id=278f888a&scoped=true", function () {
      api.rerender('278f888a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/SidebarTitle.vue"
export default component.exports